<div class="container-fluid animation-fadein" [ngClass]="rootClassName">
  <div class="form-step">
    <div class="row d-flex">
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
    </div>
    <div class="row d-flex">
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Cotizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Customizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Contacto</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Pago</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-blue">Certificado</span>
      </div>
    </div>
  </div>
  <span class="letter-style-normal text-center web-none text-bold p-3">Por favor, proporcione los datos necesarios relacionados con el beneficiario en caso de un evento de muerte accidental.</span>
  <div class="form-section">
    <div class="form-left-section form-itams">
      <img [attr.alt]="ballPink1srcNew" [attr.src]="ballPink1srcNew" class="img-fluid style-img-basketball" />
    </div>
    <form novalidate class="p-4 form-general-style mb-5 mobile-form-padding">
      <div class="p-3 background-effect mb-16px mobile-none">
        <span style="line-height: normal;font-size: 11px;display: block;"  >Por favor, proporcione los datos necesarios
          relacionados con el beneficiario en caso de un evento de muerte accidental.</span>
      </div>
      <div class="row formControlRow date mb-16px">
        <div class="dateFormControlContainer col form-small-label">
          <app-input-field [formGroup]="stepElevenForm" controlName="dayBirth" id="díaNacimiento" label="Día Nacimiento"
            [submitted]="submitted" errorMessage="Día Nacimiento" minMaxErrorMessage="El dia debe estar entre 1 y 31."></app-input-field>
          <!-- <div class="form-group">
                              <input type="text" class="form-control form-input input-form-full-space" formControlName="Día Nacimiento"
                                onclick="this.setAttribute('value', this.value);" value="">
                              <label for="firstName" class="form-input-label">Día Nacimiento</label>
                            </div> -->
        </div>
        <div class="dateFormControlContainer col form-small-label">
          <app-input-field [formGroup]="stepElevenForm" controlName="monthBirth" id="mesNacimiento" label="Mes Nacimiento"
            [submitted]="submitted" errorMessage="Mes Nacimiento" minMaxErrorMessage="El mes debe estar entre 1 y 12."></app-input-field>
          <!-- <div class="form-group">
                                          <input type="text" class="form-control form-input input-form-full-space" formControlName="Mes Nacimiento"
                                            onclick="this.setAttribute('value', this.value);" value="">
                                          <label for="firstName" class="form-input-label">Mes Nacimiento</label>
                                        </div> -->
        </div>
        <div class="dateFormControlContainer col form-small-label">
          <app-input-field [formGroup]="stepElevenForm" controlName="yearBirth" id="añoNacimiento" label="Año Nacimiento"
            [submitted]="submitted" errorMessage="Año Nacimiento" minMaxErrorMessage="El año debe estar entre 1900 y 2025."></app-input-field>
          <!-- <div class="form-group">
                                          <input type="text" class="form-control form-input input-form-full-space" formControlName="Año Nacimiento"
                                            onclick="this.setAttribute('value', this.value);" value="">
                                          <label for="firstName" class="form-input-label">Año Nacimiento</label>
                                        </div> -->
        </div>
      </div>
      <div class="row formControlRow mb-16px">
        <div class="formControlContainer col-12 col-md-6">
          <app-input-field [formGroup]="stepElevenForm" controlName="firstName" id="primerNombre" label="Primer Nombre"
            [submitted]="submitted" errorMessage="Primer Nombre"></app-input-field>
          <!-- <div class="form-group">
                                          <input type="text" class="form-control form-input input-form-full-space" formControlName="Primer Nombre"
                                            onclick="this.setAttribute('value', this.value);" value="">
                                          <label for="firstName" class="form-input-label">Primer Nombre</label>
                                        </div> -->
        </div>
        <div class="formControlContainer col-12 col-md-6">
          <app-input-field [formGroup]="stepElevenForm" controlName="lastName" id="apellidosDelTitular"
            label="Apellidos del Titular" [submitted]="submitted" errorMessage="Apellidos del Titular"></app-input-field>
          <!-- <div class="form-group">
                                          <input type="text" class="form-control form-input input-form-full-space" formControlName="Apellidos del Titular"
                                            onclick="this.setAttribute('value', this.value);" value="">
                                          <label for="firstName" class="form-input-label">Apellidos del Titular</label>
                                        </div> -->
        </div>
      </div>
      <div class="row formControlRow mb-16px">
        <div class="formControlContainer col-12 col-md-6">
          <app-input-field [formGroup]="stepElevenForm" controlName="pasaportNo" id="pasaporteNoCédula"
            label="Pasaporte o No Cédula" [submitted]="submitted" errorMessage="Pasaporte o No Cédula"></app-input-field>
          <!-- <div class="form-group">
                                          <input type="text" class="form-control form-input input-form-full-space" formControlName="Pasaporte o No Cédula"
                                            onclick="this.setAttribute('value', this.value);" value="">
                                          <label for="firstName" class="form-input-label">Pasaporte o No Cédula</label>
                                        </div> -->
        </div>
        <div class="formControlContainer col-12 col-md-6">
          <app-input-field [formGroup]="stepElevenForm" controlName="relationship" id="Relación" label="Relación"
            [submitted]="submitted" errorMessage="Relación"></app-input-field>
          <!-- <div class="form-group">
                                          <input type="text" class="form-control form-input input-form-full-space" formControlName="Relación"
                                            onclick="this.setAttribute('value', this.value);" value="">
                                          <label for="firstName" class="form-input-label">Relación</label>
                                        </div> -->
        </div>
      </div>
      <!-- <div class="row dob-section">
      </div> -->
      <div class="form-group mb-0">
        <button type="button" (click)="handleSubmit()" class="continue-btn-steps py-3">{{ loading ? 'Generando certificado...' : 'Generar Certificado'}}</button>
      </div>
       <div 
       *ngIf="certificateError"
       >
           
              <div class="alert alert-danger alert-dismissible fade show" role="alert" style="margin-top: 20px;">
                Error al generar el certificado. Por favor, inténtalo de nuevo.
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Cerrar"></button>
              </div>
           
          </div>
    </form>
    <div class="form-right-section form-itams">
      <img [attr.alt]="towerNew" [attr.src]="towerNew" class="img-fluid style-img-tower" />
    </div>
    <a href="javascript:void(0)" (click)="prevStep()" class="back-link">
      < Atrás</a>
    <div class="copy-right">
      <p>All rights reserved by BAC Financial Services. | Política de privacidad | Design by <a href="https://www.wemarkforyou.com" target="_blank">www.wemarkforyou.com</a>. </p>
      <h5>Politica de privacidad</h5>
    </div>
  </div>


<div class="modal fade" id="genrateLoadingModal" tabindex="-1" aria-labelledby="genrateLoadingModal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered send-quote-modal">
    <div class="modal-content">
      <div class="modal-body">
          <h5 class="modal-title" id="exampleModalLabel">Generando Certificado</h5>
          <img src="/assets/img/loading_logo.gif" alt="Blue Assist" class="loading-logo">
      </div>
    </div>
  </div>
</div>
 <button type="button" id="genrateLoadingModalToggle" class="btn btn-primary genrateLoadingModal" data-bs-toggle="modal"
                data-bs-target="#genrateLoadingModal" style="display: none;">Enviar Correo</button>
  

<!-- 
  <div class="quote-step12-desktop-menu2-default">
    <div class="quote-step12-component1">
      <span class="quote-step12-text"><span>By BAC Financial</span></span>
      <div class="quote-step12-group"></div>
      <div class="quote-step12-group1"></div>
    </div>
    <div class="quote-step12-frame77">
      <span class="quote-step12-text02"><span>Nosotros</span></span>
      <span class="quote-step12-text04"><span>BENEFICIOS</span></span>
      <span class="quote-step12-text06"><span>Planes</span></span>
      <span class="quote-step12-text08"><span>ASEGURADOS</span></span>
    </div>
  </div>
  <div class="quote-step12-container">
    <div class="quote-step12-frame566">
      <div class="quote-step12-frame274">
        <div class="quote-step12-frame1095 form-group">
          <div class="quote-step12-frame168">
            <div class="quote-step12-frame165">
              <span class="quote-step12-text12 Desk,P4,Bold.14">
                <span>Relación</span>
              </span>
            </div>
            <div class="quote-step12-frame169">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder"
                class="quote-step12-input"
              />
            </div>
          </div>
          <div class="quote-step12-frame174">
            <div class="quote-step12-frame1651">
              <span class="quote-step12-text14 Desk,P4,Bold.14">
                <span>Fecha de Nacimimiento</span>
              </span>
            </div>
            <div class="quote-step12-frame1691">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder1"
                class="quote-step12-input1"
              />
            </div>
          </div>
        </div>
        <div class="quote-step12-frame1101 form-group">
          <div class="quote-step12-frame1681">
            <div class="quote-step12-frame1652">
              <span class="quote-step12-text16 Desk,P4,Bold.14">
                <span>Primer Nombre</span>
              </span>
            </div>
            <div class="quote-step12-frame1692">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder2"
                class="quote-step12-input2"
              />
            </div>
          </div>
          <div class="quote-step12-frame1741">
            <div class="quote-step12-frame1653">
              <span class="quote-step12-text18 Desk,P4,Bold.14">
                <span>Apellidos</span>
              </span>
            </div>
            <div class="quote-step12-frame1693">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder3"
                class="quote-step12-input3"
              />
            </div>
          </div>
        </div>
        <div class="quote-step12-frame1097 form-group">
          <div class="quote-step12-frame1682">
            <div class="quote-step12-frame1654">
              <span class="quote-step12-text20 Desk,P4,Bold.14">
                <span>Pasaporte o Cédula de identificación</span>
              </span>
            </div>
            <div class="quote-step12-frame1694">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder4"
                class="quote-step12-input4"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="quote-step12-frame478">
      <div class="quote-step12-frame275">
        <button class="quote-step12-text22 Desk,P4,Bold.14" (click)="nextStep()">
          <span>Generar Certificado</span>
        </button>
      </div>
      <button class="quote-step12-text24 DesK,P4,Regular,16" (click)="prevStep()">
        <span>&lt; Paso anterior</span>
      </button>
    </div>
  </div>
  <div class="quote-step12-frame456">
    <span class="quote-step12-text26 Mob,P4,Intro,Light,10">
      <span>Cotizar</span>
    </span>
    <span class="quote-step12-text28 Mob,P4,Intro,Light,10">
      <span>Customizar</span>
    </span>
    <span class="quote-step12-text30 Mob,P4,Intro,Light,10">
      <span>Contacto</span>
    </span>
    <span class="quote-step12-text32 Mob,P4,Intro,Light,10">
      <span>Pago</span>
    </span>
    <span class="quote-step12-text34 Mob,P6-Intro-Bold">
      <span>Certificado</span>
    </span>
    <div class="quote-step12-progressbar"></div>
    <div class="quote-step12-progressbar1"></div>
    <div class="quote-step12-progressbar2"></div>
    <img
      [attr.alt]="ellipse25alt"
      [attr.src]="ellipse25src"
      class="quote-step12-ellipse25"
    />
    <img
      [attr.alt]="vectoralt"
      [attr.src]="vectorsrc"
      class="quote-step12-vector"
    />
    <img
      [attr.alt]="ellipse25alt1"
      [attr.src]="ellipse25src1"
      class="quote-step12-ellipse251"
    />
    <img
      [attr.alt]="vectoralt1"
      [attr.src]="vectorsrc1"
      class="quote-step12-vector1"
    />
    <img
      [attr.alt]="ellipse25alt2"
      [attr.src]="ellipse25src2"
      class="quote-step12-ellipse252"
    />
    <img
      [attr.alt]="vectoralt2"
      [attr.src]="vectorsrc2"
      class="quote-step12-vector2"
    />
    <img
      [attr.alt]="ellipse25alt3"
      [attr.src]="ellipse25src3"
      class="quote-step12-ellipse253"
    />
    <img
      [attr.alt]="vectoralt3"
      [attr.src]="vectorsrc3"
      class="quote-step12-vector3"
    />
    <img
      [attr.alt]="ellipse25alt4"
      [attr.src]="ellipse25src4"
      class="quote-step12-ellipse254"
    />
    <img
      [attr.alt]="vectoralt4"
      [attr.src]="vectorsrc4"
      class="quote-step12-vector4"
    />
  </div> -->
</div>
